import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import {
	cbChannelsizeQtyAssoc,
	colorBuyingChannelsAssoc,
	colorBuyTableColumns,
	sizeTypeCol,
} from "components/PimDashboard/DashboardComponents/Buying/BuyingSheet/data";
import { useState } from "react";
import { GlobalState } from "context/GlobalContext";
import StyleDetailsGrid from "components/ReusableComponents/StyleDetailsGrid/StyleDetailsGrid";
import DisplayInfoWithEditTab from "components/PimDashboard/CommonComponents/DisplayInfoWithEditTab/DisplayInfoWithEditTab";
import { buyingQtyColumns } from "../data";
import { converAttrToDatagridCol } from "data/globalData";
import { DataGrid } from "@mui/x-data-grid";
import { grey } from "@mui/material/colors";
import EditBuyingQtyModal from "./EditBuyingQtyModal/EditBuyingQtyModal";
import axios from "axios";

export const styleColumnsObj = [
	// { name: "Color", key: "color" },
	// { name: "Pallete", key: "pallete" },
	// { name: "Category", key: "category" },
	{ name: "Division", key: "division" },
	{ name: "Season", key: "season" },
	{ name: "Sub Brand", key: "sub_brand" },
	{ name: "Sub Category", key: "sub_category" },
];

export const generateSizeCol = (sizeTypeMaster, sizeTypeInput) => {
	let sizeTypeData = sizeTypeMaster?.filter((size) => size.size_type === sizeTypeInput);
	let sizeColData = {};
	sizeTypeData?.forEach((size) => {
		Object.keys(size).forEach((sizeCol) => {
			if (sizeTypeCol.includes(sizeCol) && size[sizeCol] !== null) {
				sizeColData[sizeCol] = {
					key: sizeCol,
					name: size[sizeCol],
				};
			}
		});
	});
	return sizeColData;
};

const generateBuyQtyTableRows = (colorBuy) => {
	let rows = [];
	colorBuy?.[colorBuyingChannelsAssoc]?.forEach((channel) => {
		channel?.[cbChannelsizeQtyAssoc]?.forEach((row) => {
			rows.push({ ...row, channel: channel.channel });
		});
	});
	return rows;
};

const PopupContent = ({
	currentBuyStaticData,
	updatedBuyData,
	setUpdatedBuyData,
	isUpdated,
	setIsUpdated,
	setDeletedSizesId,
	disableEdit = false,
}) => {
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();

	const [editModal, setEditModal] = useState(false);
	const [qtyEditModal, setQtyEditModal] = useState(false);

	const [buyQtyDgRows, setBuyQtyDgRows] = useState(generateBuyQtyTableRows(updatedBuyData));

	const handleEditModalOpen = () => {
		setEditModal(true);
	};
	const handleQtyEditModalOpen = () => {
		setQtyEditModal(true);
	};

	const handleQtyEditModalClose = () => {
		setQtyEditModal(false);
	};

	const saveBuyDetailsFun = async (data, columns) => {
		setLoadingOpen(true);
		try {
			await axios.post("/api/color_buying/update_color_buy_details", data).then((res) => {
				setUpdatedBuyData((prev) => ({ ...prev, ...data }));
				setEditModal(false);
				setLoadingOpen(false);
			});
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Server Error for size types `,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		}
	};

	const buyingQtyChangeCallback = (updatedChannelBuy) => {
		setUpdatedBuyData((prev) => ({
			...prev,
			[colorBuyingChannelsAssoc]: updatedChannelBuy,
		}));
	};

	return (
		<Box>
			<Stack display="flex" flexDirection="row" columnGap={1} flexGrow={1} boxSizing="border-box">
				{/* left */}
				<StyleDetailsGrid
					sx={{ width: "23%", mb: "5px" }}
					data={currentBuyStaticData}
					styleColumnsObj={styleColumnsObj}
					fieldWidth={"98%"}
					displayGroups={["color", "designer_suggestions"]}
					hideFiles={true}
					groupHeight="50%"
				/>
				<Divider orientation="vertical" flexItem />

				<Stack width="75%" pt={1} spacing={1}>
					<Box width="100%" justifyContent="space-between" display="flex" alignItems="center">
						<Typography variant="h6">Basic Details</Typography>
						<Button
							variant="contained"
							onClick={handleEditModalOpen}
							size="small"
							sx={{ display: disableEdit ? "none" : "block" }}>
							Edit
						</Button>
					</Box>
					<DisplayInfoWithEditTab
						columnData={Object.values(colorBuyTableColumns)}
						modalOpen={editModal}
						setModalOpen={setEditModal}
						submitFunction={saveBuyDetailsFun}
						data={updatedBuyData}
						width={"32.6%"}
					/>

					<Box width="100%" justifyContent="space-between" display="flex" alignItems="center">
						<Typography variant="h6">Buying Qty</Typography>
						<Button
							variant="contained"
							onClick={handleQtyEditModalOpen}
							size="small"
							sx={{ display: disableEdit ? "none" : "block" }}>
							Edit
						</Button>
					</Box>

					<DataGrid
						rows={buyQtyDgRows}
						columns={Object.values(buyingQtyColumns).map((row) => converAttrToDatagridCol(row))}
						sx={{
							maxHeight: "450px",
							"& .MuiDataGrid-row": {
								// borderBottom: "1px solid lightgray",
								cursor: "pointer",
								border: "none",
							},
							"& .MuiDataGrid-columnHeader": {
								cursor: "pointer",
								background: grey[300],
							},
							"& .MuiDataGrid-columnHeaders": {
								background: grey[300],
								// mb: 2,
								border: "none",
								borderRadius: 1,
								// padding: "10px 0px",
							},
							"& .MuiDataGrid-footer": {
								background: grey[300],
								// mb: 2,
								border: "none",
								borderRadius: 1,
								// padding: "10px 0px",
							},
						}}
						columnHeaderHeight={35}
						rowHeight={40}
						disableRowSelectionOnClick
						pageSizeOptions={[20, 50]}
					/>

					<EditBuyingQtyModal
						modalOpen={qtyEditModal}
						handleModalClose={handleQtyEditModalClose}
						updatedBuyData={updatedBuyData}
						setUpdatedBuyData={setUpdatedBuyData}
						currentBuyStaticData={currentBuyStaticData}
						setDeletedSizesId={setDeletedSizesId}
						isUpdated={isUpdated}
						setIsUpdated={setIsUpdated}
						dataSaveCallback={buyingQtyChangeCallback}
					/>
				</Stack>
			</Stack>
		</Box>
	);
};

export default PopupContent;
